import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatTabsModule, MatTabLabelWrapper } from '@angular/material/tabs';
import { I18NextModule } from 'angular-i18next';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule, NgItemLabelDirective } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CdkTableModule } from '@angular/cdk/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { DashboardModule } from '../dashboards/dashboard.module';
import { LazyElementDirective } from "@angular-extensions/elements";

import { PauseReasonsComponent } from './pausereasons/pausereasons.component';
import { UserLogsComponent } from './userlogs/userlogs.component';
import { AccessLogsComponent } from './userlogs/logscomponents/access-logs.component';
import { AuditLogsComponent } from './userlogs/logscomponents/audit-logs.component';
import { ProfileTemplatesComponent } from './profiletemplates/profiletemplates.component';
import { UsersFilterComponent } from './usersFilter/usersFilter.component';
import { GetFilterComponent } from './usersFilter/getFilter/getFilter.component';
import { SelectResourceDialogComponent } from './usersFilter/getFilter/select-resource-dialog.component';
import { UsergroupsComponent } from './usergroups/usergroups.component';
import { AddUsergroupDialogComponent } from './usergroups/dialogs/add-usergroup-dialog.component';
import { AddTemplateProfileDialogComponent } from './usergroups/dialogs/add-template-profile-dialog.component';
import { AddSkillsComponent } from './usergroups/add-skills/add-skills.component';
import { UsersComponent } from './users/users.component';
import { EditUserComponent } from './users/edit-user/edit-user.component';
import { EditGroupNumberComponent } from './users/edit-group-number/edit-group-number.component';
import { FileUploadDialogComponent } from '../shared/dialogs/file-upload-dialog/file-upload-dialog.component';
@NgModule({
  declarations: [
    PauseReasonsComponent,
    UserLogsComponent,
    AccessLogsComponent,
    AuditLogsComponent,
    ProfileTemplatesComponent,
    UsersFilterComponent,
    GetFilterComponent,
    SelectResourceDialogComponent,
    UsersComponent,
    EditUserComponent,
    EditGroupNumberComponent,
    UsergroupsComponent,
    AddUsergroupDialogComponent,
    AddTemplateProfileDialogComponent,
    AddSkillsComponent,
    FileUploadDialogComponent
  ],
  imports: [
    DashboardModule,
    CommonModule,
    BrowserModule,
    FormsModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    CdkTableModule,
    MatChipsModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SharedModule,
    NgSelectModule,
    RouterModule,
    DragDropModule,
    MatProgressBarModule,
    I18NextModule.forRoot(),
    LazyElementDirective,
    MatTabLabelWrapper,
    NgItemLabelDirective
],
  exports: [
    PauseReasonsComponent,
    UserLogsComponent,
    AuditLogsComponent,
    AccessLogsComponent,
    ProfileTemplatesComponent,
    UsersFilterComponent,
    GetFilterComponent
  ]
})
export class UsersModule { }
